<template>
    <!-- https://tailwindui.com/components/application-ui/lists/grid-lists#component-5d72b187beb968e12db89fe49f272b18 -->
    <li class="flex flex-col col-span-1 text-center bg-white rounded-lg shadow">
        <div class="flex flex-col flex-1 px-8 py-4">
<!--            <img class="shrink-0 w-32 h-32 mx-auto bg-black rounded-full" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=60" alt="">-->
            <p class="mt-6 mb-0 font-medium text-md text-gray-1000">{{probeType}}</p>
            <div class="w-full mb-4">
                <span v-show="point.inputNumber"
                      :class="pillColorBasedOnInputNumber"
                        class="w-auto px-2 py-1 text-sm font-bold leading-4 rounded-full">Input {{inputNumber}}</span>
            </div>
            <dl class="flex flex-col justify-between grow mt-1 mb-2">
                <dd class="text-sm leading-5 text-gray-500">
                    <span class="mr-2 text-xs font-light text-grey-800">Probe Serial:</span>
                    <span class="text-gray-500">{{probeSerial}}</span>
                </dd>
                <dd v-show="hasLoaded" class="p-1 text-xs font-medium leading-4 leading-5 text-teal-800 bg-green-100 rounded-full">
                    Checked in {{lastCheckinTime}}
                </dd>
            </dl>
            <select2-group :options='areaZones'
                           :close-on-select="true"
                           :multiple="false"
                           v-model='zone'
                           placeholder="Select a Zone"
                           class="p-2 m-2"
            ></select2-group>
            <div class="p-2 m-2">
                <floating-input     :id="'device_name_' + meter.ID"
                                    v-model:value="deviceName"
                                    label="Point Name"
                                    :centered="true"
                ></floating-input>
            </div>
            <div v-if="canAssignTags" class="p-2 m-2">
                <select2-group :options="tagOptions"
                               :close-on-select="true"
                               :multiple="false"
                               v-model="selectedTagId"
                               placeholder="Select a Category (optional)"
                               class="p-2 m-2"
                ></select2-group>
            </div>
        </div>
        <div class="border-t border-gray-200">
            <div class="flex -mt-px">
                <div class="flex flex-1 w-0 border-gray-200">
                    <div v-if="needsSaved"
                         @click="save"
                         class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-bl-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-floppy-disk"></span>
                        <span class="ml-3">Save</span>
                    </div>
                    <div v-else
                         class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-bl-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-check"></span>
                        <span class="ml-3">Saved</span>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    import Select2Group from "@/components/elements/select2-group";
    import axios from "axios";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    export default {
        name: "InstallWizardElectronicInstallCard",
        components: {Select2Group},
        mixins: [SonicuCoreMixin],
        props: {
            point: Object,
            areaZones: Object,
            canAssignTags: {
                type: Boolean,
                default: false,
            },
            sonicuAiTags: {
                type: Array,
                default: () => [],
            },
        },
        data(){
            return{
                deviceName: this.getNonDefaultName(),
                savedDeviceName: this.getNonDefaultName(),
                zone: this.getZoneDefault(),
                lastCheckinTime: '',
                hasLoaded: false,
                meter: this.point.meter,
                needsSaved: true,
                selectedTagId: null,
            }
        },
        mounted() {
            // if(this.deviceName.length > 0) && {}
            if(this.deviceName.length > 0 && this.isZoneOk()){
                this.needsSaved = false;
                this.$emit('saved', this.point);
            }
            this.getDeviceData();
        },
        methods: {
            save(){
                axios
                    .put(this.company.buildCompanyApiInternalRoute('wizard/electronic-install/'),
                        {
                            meter: this.point.meter.ID,
                            zone: this.zone,
                            name: this.deviceName,
                            tag_id: this.selectedTagId ? parseInt(this.selectedTagId) : null,
                        })
                    .then(response => {
                        this.point.meter.name = this.deviceName;
                        this.point.meter.ZoneID = this.zone;
                        this.needsSaved = false;
                        this.$emit('saved', this.point);
                    });

            },
            getDeviceData(){
                axios
                    .get(this.company.buildCompanyApiInternalRoute('meters/' + this.point.meter.ID))
                    .then(response =>{
                        this.meter = response.data.data;
                        this.lastCheckinTime = response.data.data.lastCheckinTimeReadable;
                        this.hasLoaded = true;
                    });
            },
            getNonDefaultName(){
                if(this.point.meter.is_default_name){
                    return '';
                }
                if(this.point.meter === null){
                    return '';
                }
                return this.point.meter.Name;
            },
            getZoneDefault(){
                return this.point.meter.ZoneID.toString();
            },
            isZoneOk(){
                let zoneOk = false;
                _.forOwn(this.areaZones, (areaOfZones, areaName) => {
                    if(areaOfZones[this.zone] !== undefined){
                        zoneOk = true;
                    }
                } )
                return zoneOk;
            }
        },
        computed: {
            tagOptions() {
                let group = {}
                this.sonicuAiTags.forEach(tag => {
                    group[tag.id.toString()] = tag.name
                })
                return { 'Category': group }
            },
            probeType(){
                if(this.point.probe !== undefined && this.point.probe !== null){
                    return this.point.probe.probe_type;
                }
                return null;
            },
            probeSerial(){
                return this.point.probe_serial;
            },
            inputNumber(){
                return this.point.inputNumber;
            },
            pillColorBasedOnInputNumber(){
                if(this.inputNumber === 1){
                    return 'bg-blue-100 text-blue-800';
                }
                if(this.inputNumber === 2){
                    return 'bg-green-100 text-green-800';
                }
                if(this.inputNumber === 3){
                    return 'bg-yellow-100 text-yellow-800';
                }
                if(this.inputNumber === 4){
                    return 'bg-red-100 text-red-800';
                }
            }
        },
        watch: {
            zone: function(val){
                this.needsSaved = true;
                this.$emit('needs-saved', this.point);
            },
            deviceName: function(val){
                this.needsSaved = true;
                this.$emit('needs-saved', this.point);
            },
            selectedTagId: function(val){
                this.needsSaved = true;
                this.$emit('needs-saved', this.point);
            }
        }
    }
</script>

<style scoped>

</style>
